import { NavBar as Bar } from "nq-component";

function NavBar() {
  return <Bar className="shadow-sm" logo="/assets/images/logo.png"></Bar>;
}

export default NavBar;
